import React, { useEffect, useState } from 'react'
import { EidTree } from 'packages/eid-controls'

const TreeFilter = ({
    url,
    initialValue,
    value,
    onChange,
    selectedValueIndicatorProp,
    searchPlaceholder,
    version = "v1",
    ...rest
}) => {
    const [selectedItem, setSelectedItem] = useState(value)

    useEffect(() => {
        if (value !== selectedItem) {
            setSelectedItem(value)
        }
    }, [value])

    useEffect(() => {
        onChange(selectedItem)
    }, [selectedItem])

    let basicUrl = `${url}`

    return (
        <EidTree
            url={basicUrl}
            initialValue={initialValue}
            onChange={(item) => setSelectedItem(item)}
            value={value}
            searchPlaceholder={searchPlaceholder}
            version={version}
            {...rest}
        />
    )
}

export default TreeFilter
